<style></style>
<template>
    <div class="invites">
        <div class="form-group">
            <label>Edit Registration Code:</label>
            <input v-model="codeCopy.code" type="text" class="form-control"></input>
        </div>
        <div class="form-group">
            <label>Partner:</label>
            <select v-model="codeCopy.partner_id" class="form-control mb-3">
                <option v-for="option in partner_options" :value="option.value">{{ option.text }}</option>
            </select>
        </div>
        <div class="form-group">
            <label>TA Consultant:</label>
            <select v-model="codeCopy.consultant_id" class="form-control mb-3">
                <option v-for="option in consultant_options" :value="option.value">{{ option.text }}</option>
            </select>
        </div>
        <div class="form-group">
            <fieldset>
                <legend class="col-form-label pt-0">Status:</legend>
                <template v-for="(option,index) in status_options">
                    <div class="custom-control custom-control-inline custom-radio">
                        <input v-model="codeCopy.enabled" type="radio" :value="option.value" :id="`statusChoice${index}`" class="custom-control-input" aria-label="Radio button for registration code status" />
                        <label :for="`statusChoice${index}`" class="custom-control-label">{{ option.text }}</label>
                    </div>
                </template>
            </fieldset>
        </div>
        <button class="btn btn-orange-blue" @click="updateCode">Save Changes</button>
        <button class="btn btn-blue-blue float-right" @click="confirmDelete()">Delete Code</button>
    </div>
</template>
<script>
    import { mapWritableState } from 'pinia';
    import { useRegistrationCodesStore } from './store.js';

    export default {
        props: {
            value: {
                type: [null, Object]
            },
            partners: {
                type: Array,
                required: true
            },
            consultants: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                codeCopy: {},
                status_options: [
                    { text: 'Enabled', value: 1 },
                    { text: 'Disabled', value: 0 }
                ],
                confirmModal: false
            }
        },
        watch: {
            value: function (to, from) {
                this.syncCode()
            }
        },
        computed: {
            partner_options: function () {
                let options = [];
                for (var i = 0; i < this.partners.length; i++) {
                    options.push({'value':this.partners[i].id, 'text': this.partners[i].name})
                }
                return options
            },
            consultant_options: function () {
                let options = [];
                for (var i = 0; i < this.consultants.length; i++) {
                    options.push({'value':this.consultants[i].id, 'text': this.consultants[i].name})
                }
                return options
            },
            ...mapWritableState(useRegistrationCodesStore, [
                'refreshCodes',
                'showModal'
            ]),
        },
        methods: {
            updateCode(){
                axios.patch('/api/registration-codes/'+ this.value.id, this.codeCopy)
                .then(response => {
                    this.codeCopy = {}
                    this.refreshCodes = !this.refreshCodes; // toggle to trigger reg code refresh
                    this.showModal = false;
                })
                .catch(error => {
                    console.error(error)
                })
            },
            confirmDelete() {
                this.$emit('confirmCodeDelete');
            },
            syncCode() {
                this.codeCopy = (this.value) ? JSON.parse(JSON.stringify(this.value)) : {};
                
            }
        },
        mounted() {
            this.syncCode();
        }
    }
</script>